export const CHART_COLORS = {
  primary: "#4f39f6",
  primaryLight: "#ecebff",
  available: "#10b981",
  blocked: "#f59e0b",
  booked: "#3b82f6",
  sold: "#475569",
  won: "#10b981",
  lost: "#ef4444",
  target: "#94a3b8",
  collected: "#4f39f6",
  overdue: "#ef4444",
  outstanding: "#f59e0b",
}

export const LOSS_REASON_LABELS = {
  price: "Price",
  budget_mismatch: "Budget Mismatch",
  location: "Location",
  lost_to_competitor: "Lost to Competitor",
  not_ready: "Not Ready",
  financing_failed: "Financing Failed",
  unresponsive: "Unresponsive",
  duplicate: "Duplicate",
  other: "Other",
  unspecified: "Unspecified",
}

export const DATE_PRESETS = [
  { key: "7d", label: "Last 7 days", days: 7 },
  { key: "30d", label: "Last 30 days", days: 30 },
  { key: "90d", label: "Last 90 days", days: 90 },
  { key: "month", label: "This month" },
  { key: "quarter", label: "This quarter" },
]

export function presetToRange(key) {
  const now = new Date()
  const isoDate = (d) => d.toISOString().slice(0, 10)

  if (key === "month") {
    const from = new Date(now.getFullYear(), now.getMonth(), 1)
    const to = new Date(now.getFullYear(), now.getMonth() + 1, 0)
    return { from: isoDate(from), to: isoDate(to) }
  }
  if (key === "quarter") {
    const qMonth = Math.floor(now.getMonth() / 3) * 3
    const from = new Date(now.getFullYear(), qMonth, 1)
    const to = new Date(now.getFullYear(), qMonth + 3, 0)
    return { from: isoDate(from), to: isoDate(to) }
  }
  const preset = DATE_PRESETS.find((p) => p.key === key)
  const days = preset?.days || 30
  const to = new Date(now)
  const from = new Date(now)
  from.setDate(from.getDate() - days)
  return { from: isoDate(from), to: isoDate(to) }
}

export function formatINR(value) {
  if (value == null) return "—"
  const num = Number(value)
  if (isNaN(num)) return "—"

  const abs = Math.abs(num)
  const sign = num < 0 ? "-" : ""

  if (abs >= 1_00_00_000) return `${sign}₹${(abs / 1_00_00_000).toFixed(2)} Cr`
  if (abs >= 1_00_000) return `${sign}₹${(abs / 1_00_000).toFixed(2)} L`
  if (abs >= 1_000) return `${sign}₹${(abs / 1_000).toFixed(1)}K`
  return `${sign}₹${abs.toLocaleString("en-IN")}`
}

export function formatNumber(value) {
  if (value == null) return "—"
  return Number(value).toLocaleString("en-IN")
}
